import './MicrosoftCopilotLauncher.css'

/** Microsoft 365 Copilot (školský chat) — otevře se v nové záložce (fáze 1). */
const M365_COPILOT_CHAT_URL =
  'https://m365.cloud.microsoft/chat/?titleId=T_3f20043b-fece-598f-1e00-62c45b74c50b&source=embedded-builder'

export default function MicrosoftCopilotLauncher() {
  return (
    <a
      className="m365-copilot-launcher"
      href={M365_COPILOT_CHAT_URL}
      target="_blank"
      rel="noopener noreferrer"
      title="Otevřít Microsoft Copilot (M365) v nové záložce"
      aria-label="Otevřít Microsoft Copilot (M365) v nové záložce"
    >
      <span className="m365-copilot-launcher__icon" aria-hidden>
        ✨
      </span>
      <span className="m365-copilot-launcher__text">Copilot</span>
    </a>
  )
}
